import { Component, Input } from '@angular/core';
import { TransitionPreventorDirective } from '../../directives/transition-preventor.directive';

@Component({
  selector: 'app-circle-progress-bar',
  templateUrl: './circle-progress-bar.component.html',
  styleUrls: ['./circle-progress-bar.component.scss'],
  standalone: true,
  imports: [TransitionPreventorDirective],
})
export class CircleProgressBarComponent {
  @Input() progress = 0; // percent
  @Input() strokeWidth = 20; // px
  @Input() size = 28; // px
  @Input() slowTransition = false;
  @Input() color = '';
}
